var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.2495458 15.4843064l4.0460275-4.2080715c-1.0403048-1.2366674-1.6102939-2.7926482-1.6102939-4.4124916C2.6852794 3.0791349 5.7644144 0 9.5490227 0c3.7846084 0 6.8637433 3.0791349 6.8637433 6.8637433 0 3.7846083-3.0791349 6.8637433-6.8637433 6.8637433-1.4207948 0-2.7747428-.4285363-3.932328-1.2420391l-4.0767651 4.2400028C1.3695297 16.9024155 1.1403403 17 .8947377 17c-.232472 0-.4530071-.0886318-.6204227-.2497806-.355721-.3422919-.3670611-.9098936-.0247692-1.265913zM9.5490227 1.7905417c-2.797423 0-5.0732015 2.2757786-5.0732015 5.0732016 0 2.797423 2.2757785 5.0732015 5.0732015 5.0732015 2.797423 0 5.0732016-2.2757785 5.0732016-5.0732015 0-2.797423-2.2757786-5.0732016-5.0732016-5.0732016z",
    fill: "#C1CEDE",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.e75c7b262dcb9cc71cd9f33d8fd20af3.svg";
export { ForwardRef as ReactComponent };